var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { AutoComplete, Spin } from 'antd';
import { createDeepResultObject, getTypeNames, filterBy } from 'utils/helpers';
import { InsurancePlanAssignmentStatusType, PlanCategoryType } from 'generated/types';
import { useInsurancePlanFromIdQuery } from 'apollo/queries/INSURANCE_PLAN_FROM_ID';
import { usePlansWithBenefitsQuery } from 'apollo/queries/PLANS_WITH_BENEFITS';
var SCROLL_GAP = 10;
var InsuranceAutocomplete = function (_a) {
    var _b, _c;
    var memberId = _a.memberId, defaultValue = _a.defaultValue, onChange = _a.onChange, onPlanSelect = _a.onPlanSelect, isCarePlan = _a.isCarePlan;
    var _d = useState(), displayValue = _d[0], setDisplayValue = _d[1];
    var _e = useState([]), options = _e[0], setOptions = _e[1];
    var _f = useState(null), search = _f[0], setSearch = _f[1];
    var _g = useState(false), fetching = _g[0], setFetching = _g[1];
    var _h = usePlansWithBenefitsQuery({
        variables: {
            filters: __assign(__assign({}, (search && { search: search })), (memberId && {
                member_id: memberId,
                eligibility_status: InsurancePlanAssignmentStatusType.Current
            }))
        }
    }), data = _h.data, loading = _h.loading, fetchMore = _h.fetchMore;
    var _j = useInsurancePlanFromIdQuery({
        variables: { id: defaultValue },
        skip: !defaultValue,
        fetchPolicy: 'cache-first'
    }), planNameData = _j.data, planNameLoading = _j.loading;
    var insurance_plans = ((_b = data === null || data === void 0 ? void 0 : data.insurance_plans) === null || _b === void 0 ? void 0 : _b.nodes) || [];
    var medicalPlan = insurance_plans.find(function (item) { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.category) === null || _a === void 0 ? void 0 : _a.code) === PlanCategoryType.MedicalCare; });
    var pageInfo = ((_c = data === null || data === void 0 ? void 0 : data.insurance_plans) === null || _c === void 0 ? void 0 : _c.pageInfo) || {};
    var hasNextPage = pageInfo.hasNextPage, endCursor = pageInfo.endCursor;
    var stringifiedPlans = JSON.stringify(insurance_plans);
    var loadMore = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (fetching === endCursor)
                        return [2 /*return*/, false];
                    setFetching(endCursor);
                    return [4 /*yield*/, fetchMore({
                            variables: {
                                cursor: endCursor
                            },
                            updateQuery: function (previousResult, _a) {
                                var _b, _c, _d;
                                var fetchMoreResult = _a.fetchMoreResult;
                                var newNodes = (_b = fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.insurance_plans) === null || _b === void 0 ? void 0 : _b.nodes;
                                var prevNodes = (_c = previousResult === null || previousResult === void 0 ? void 0 : previousResult.insurance_plans) === null || _c === void 0 ? void 0 : _c.nodes;
                                var filteredNodes = filterBy(__spreadArray(__spreadArray([], prevNodes, true), newNodes, true), 'id');
                                var newPageInfo = (_d = fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.insurance_plans) === null || _d === void 0 ? void 0 : _d.pageInfo;
                                var typeNames = getTypeNames(['insurance_plans'], previousResult);
                                var newResult = createDeepResultObject(['insurance_plans'], {
                                    nodes: filteredNodes,
                                    pageInfo: newPageInfo
                                }, typeNames);
                                return newNodes.length ? newResult : previousResult;
                            }
                        })];
                case 1:
                    _a.sent();
                    setFetching(false);
                    return [2 /*return*/, true];
            }
        });
    }); };
    var onPopupScroll = function (e) {
        var target = e.target;
        var maxScroll = target.scrollHeight - target.clientHeight;
        var currentScroll = target.scrollTop;
        if (!loading &&
            !fetching &&
            hasNextPage &&
            maxScroll - currentScroll <= SCROLL_GAP)
            loadMore();
    };
    var onClear = function () {
        onChange(undefined);
        setDisplayValue(undefined);
        if (onPlanSelect)
            onPlanSelect(undefined);
    };
    var onSelect = function (_, item) {
        var value = item.value, label = item.label, tiers = item.tiers;
        if (value) {
            onChange(value);
            setDisplayValue(label);
            if (onPlanSelect)
                onPlanSelect(tiers);
        }
        else
            onClear();
    };
    useEffect(function () {
        if (!insurance_plans.length)
            setOptions([]);
        else
            setOptions(insurance_plans.map(function (plan) { return ({
                value: plan.id,
                label: plan.display_name,
                tiers: plan.insurance_tiers
            }); }));
        // eslint-disable-next-line
    }, [stringifiedPlans]);
    useEffect(function () {
        var fetchedPlan = planNameData === null || planNameData === void 0 ? void 0 : planNameData.insurance_plan;
        if (fetchedPlan) {
            setDisplayValue(fetchedPlan === null || fetchedPlan === void 0 ? void 0 : fetchedPlan.display_name);
            if (onPlanSelect)
                onPlanSelect(fetchedPlan.insurance_tiers);
        }
        // eslint-disable-next-line
    }, [planNameLoading]);
    useEffect(function () {
        if (isCarePlan && medicalPlan) {
            setDisplayValue(medicalPlan.display_name);
            onChange(medicalPlan.id);
            if (onPlanSelect)
                onPlanSelect(medicalPlan.insurance_tiers);
        }
    }, [medicalPlan]);
    useEffect(function () {
        if (!defaultValue) {
            setDisplayValue(undefined);
        }
    }, [defaultValue]);
    return (_jsx("div", { style: { minWidth: '15%' }, children: _jsx(Spin, { spinning: loading || !!fetching || planNameLoading, children: _jsx(AutoComplete, { options: options, onSelect: onSelect, showSearch: { onSearch: setSearch }, onClear: onClear, onPopupScroll: onPopupScroll, value: displayValue, placeholder: "Insurance", allowClear: true, style: { width: '100%' }, "data-test": "insuranceAutocomplete" }) }) }));
};
export default InsuranceAutocomplete;
